.header {
  background-color: var(--mantine-color-sand-5);
}

.title-mobile {
  @media screen and (max-width: $mantine-breakpoint-xs) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
}

.image-logo {
  max-height: 100px;
  height: 55px;
  @media screen and (max-width: $mantine-breakpoint-xs) {
    width: 100%;
    display: flex;
    object-fit: contain;
    max-height: 55px;
  }
}

.subtitle-mobile {
  @media screen and (max-width: $mantine-breakpoint-xs) {
    justify-content: center;
    row-gap: var(--mantine-spacing-xs);
    gap: 0.3rem;
  }
}

.subtitle-mobile p {
  @media screen and (max-width: $mantine-breakpoint-xs) {
    margin-right: 0px;
    font-size: var(--mantine-font-size-xs);
  }
}
.form-mobile {
  @media screen and (max-width: $mantine-breakpoint-sm) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.form-mobile label {
  font-size: var(--mantine-font-size-md);
  @media screen and (max-width: $mantine-breakpoint-sm) {
    font-size: var(--mantine-font-size-sm);
  }
}
